































































































import ModalV2 from '@/components/modals/ModalV2.vue'
import Vue from 'vue'
import Component from 'vue-class-component'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import Sortable from '@/directives/sortable'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import { EUserPermissions, IFacility } from '@zunta/configurations'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import Icon from '@/components/Icon.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import { FacilityModule } from '@/store/modules/facility.module'
import { getModule } from 'vuex-module-decorators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { required } from 'vuelidate/lib/validators'
import { ResidentModule } from '@/store/modules/resident.module'

@Component({
  directives: {
    sortable: new Sortable()
  },
  components: { InputValidator, Icon, LoaderWrapper, SelectV2, Checkbox, ModalV2 }
})
export default class ReceiptOrderModal extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  EUserPermissions: any = EUserPermissions
  user: User = Api.getUser() as User

  facilityData: Partial<IFacility> = {
    sendToAllContactsInOrder: false,
    sendCopyToContactsWithEmails: false
  }

  selectedTypeOfContacts: string[] = []

  isRecipientOpened: boolean = false
  isLoading: boolean = false

  validations (): any {
    return {
      selectedTypeOfContacts: {
        $each: {
          required
        }
      }
    }
  }

  get residentTypeOfContactList () {
    return this.$store.state.resident.typeOfContactList
  }

  get selectedFacility (): IFacility {
    return this.$store.state.facility.selectedFacility
  }

  mounted () {
    this.facilityData = { ...this.selectedFacility }
    this.selectedTypeOfContacts = (this.selectedFacility.residentMailContacts || []).slice(0)
    if (this.residentTypeOfContactList.length) {
      this.selectedTypeOfContacts = this.selectedTypeOfContacts.filter(selectedType => this.residentTypeOfContactList.includes(selectedType))
    }
    if (this.selectedTypeOfContacts.length === 0) {
      this.selectedTypeOfContacts.push('')
    }
  }

  getLabel (index: number) {
    if (index === 1) {
      return `${index}st place`
    } else if (index === 2) {
      return `${index}nd place`
    } else if (index === 3) {
      return `${index}rd place`
    }
    return `${index}th place`
  }

  contactSelectList (selectedItem: string) {
    const tmp: any = this.residentTypeOfContactList
      .filter((typeOfContact: string) =>
        !this.selectedTypeOfContacts
          .filter((it: string) => it === typeOfContact && it !== selectedItem).length
      )
      .map((typeOfContact: string) => ({
        key: typeOfContact,
        value: typeOfContact,
        content: typeOfContact === 'Resident' ? 'Resident (this is not contact type its the resident themselves)' : typeOfContact
      }))

    return [
      {
        key: ' ',
        value: '',
        content: ''
      },
      ...tmp
    ]
  }

  add () {
    this.selectedTypeOfContacts.push('')
  }

  remove (index: number) {
    this.selectedTypeOfContacts.splice(index, 1)
  }

  updateSelectedOrder (event: any) {
    const { oldIndex, newIndex } = event
    if (this.selectedTypeOfContacts[oldIndex]) {
      const item = this.selectedTypeOfContacts[newIndex]
      this.$set(this.selectedTypeOfContacts, newIndex, this.selectedTypeOfContacts[oldIndex])
      this.$set(this.selectedTypeOfContacts, oldIndex, item)
    }
  }

  updateValue (value: any, index: number) {
    this.$set(this.selectedTypeOfContacts, index, value)
  }

  async save () {
    if (!this.selectedFacility) {
      return
    }

    this.$v.$touch()
    if (this.$v.$anyError) {
      return
    }

    if (!this.user.hasPermissionFor(EUserPermissions.EDIT_STATEMENT_SETTINGS)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Edit Statement Settings`,
        icon: 'warning'
      })
      return
    }

    try {
      this.isLoading = true
      await this.facilityModuleInstance.updateFacility({
        id: this.selectedFacility.id as number,
        data: {
          ...this.facilityData,
          residentMailContacts: this.selectedTypeOfContacts.map((item: string) => item.replace(/_/g, ' '))
        }
      })

      await this.residentModuleInstance.initResidentContactsUsedForMailing({
        facilityId: this.selectedFacility.id as number,
        order: this.selectedTypeOfContacts,
        override: true
      })
    } finally {
      this.isLoading = false
      this.$emit('close')
    }
  }
}
